// extracted by mini-css-extract-plugin
export default {"message":"DashboardsDelete_message__xhyFC"};